module.exports = __webpack_public_path__ + "img/add-photo.38e64bd1.png";